import React, { useEffect, useState } from "react";
import styles from './ShareOptionContainer.module.scss'
import { convertToModule } from "factory/utils/clientUtils";
import HK from "factory/modules/HK";
import PDPEventTracker from "components/Pdp/common/PDPEventTracker";
import { __isCallBackExist } from "factory/modules/HK_service";
import { isLoginPopupAction } from "components/common/login/action";
import { connect } from "react-redux";
const ShareOptionContainer = ({ handleCallBack, promotion_name, creative_slot, referData, ...props }) => {
    const [isCoppied, setIsCoppied] = useState(false);
    const [firstPurchaseNotHappend, setFirstPurchaseNotHappend] = useState(true);
    const [referEarnCode, setReferEarnCode] = useState(null);
    const rneBaseUrl = window.location.origin;

    const icons = [
        '/ReferAndEarn/gmail.svg',
        '/ReferAndEarn/whatsaap.svg',
        '/ReferAndEarn/messanger.svg',
        '/ReferAndEarn/ShareBTN.svg'
    ]

    useEffect(() => {
        if (referData) {
            getReferEarnCode();
        }
    }, [referData])

    const handleLoginCTA = () => {
        props.dispatch(isLoginPopupAction({ isShow: true, activeTab: "login", redirectTo: '/ReferAndEarn' }));
    }

    const getReferEarnCode = () => {
        if (referData && referData.tbCouponCode) {
            setReferEarnCode(referData.tbCouponCode);
            setFirstPurchaseNotHappend(false);
        } else {
            setReferEarnCode(null);
            setFirstPurchaseNotHappend(true)
        }
    }
    const handleReferAndEvent = (creative_name) => {
        let data = {
            promotion_name: promotion_name,
            creative_slot: 1,
            creative_name: creative_name,
            tbAvailablePoints: referData.tbAvailablePoints || 0,
            tbTotalPoints: referData.tbTotalPoints || 0,
            referalPoints: referData.referAndEarnAmountToBeGet || 0,
            items: []
        }
        if (referEarnCode) {
            data.items = [
                { coupon: referEarnCode }
            ]
        }

        __isCallBackExist(handleCallBack) && handleCallBack(data)
    }

    const getShareDetails = () => {
        return `Hey, use my code ${referEarnCode} on Gritzo and get a discount of ${referData && referData.referAndEarnAmountToBeGet} on your first order, I will also get a reward of ${referData && referData.referAndEarnAmountToBeGet}. Hurry up and sign up on ${rneBaseUrl + '/?ReferralCode=' + referEarnCode}&utm_campaign=refandearn to make your purchase.`;
    }

    const openSharePopup = (index) => {
        handleReferAndEvent('share');
        const shareText = getShareDetails();
        const shareTitle = referEarnCode.toString();
        if (navigator.share) {
            navigator.share({
                title: shareTitle,
                text: shareText.toString(),
            })
                .then(() => console.log('Successful share'))
                .catch((error) => console.log('Error sharing', error));

        }
        let clickStream = {
            widgetName: 'Share Icon',
            eventName: "SHARE_ICON_CLICK",

        }
        HK.triggerComponentClickEvent(PDPEventTracker.getData(clickStream, 'Refer and Earn'));;
    }

    return (
        <div className={convertToModule(styles, 'share-code-container')}>
            {
                !HK.loggedIn() || firstPurchaseNotHappend
                    ?
                    <div className={convertToModule(styles, 'non-logged-in-overlay')}>
                        {
                            !HK.loggedIn() ?
                                <div className={convertToModule(styles, "ttl-text")}>
                                    {' Please login/ signup to start earning by referring your friends.'}
                                </div>
                                :
                                firstPurchaseNotHappend ?
                                    <div className={convertToModule(styles, 'without-purcase-login')}>
                                        <div className={convertToModule(styles, 'ttl-first-cntr')}>
                                            Refer your friends & earn 200 on the first order of every friend.
                                        </div>
                                        <div className={convertToModule(styles, 'ttl-first-cntr-1')}>
                                            Please make a purchase to avail the Refer and Earn rewards.
                                        </div>
                                    </div>
                                    : <></>
                        }
                        {
                            !HK.loggedIn() ?
                                <div className={convertToModule(styles, 'login-rfr-earn-btn')} onClick={() => handleLoginCTA()}>
                                    Yes! I want to Refer & Earn
                                </div>
                                : <></>
                        }
                    </div>
                    : <></>
            }
            <div className={convertToModule(styles, 'ttl')}>
                Did you know?
            </div>

            {
                referData && referData.referAndEarnAmountToBeGet ?
                    <div className={convertToModule(styles, 'desc')}>
                        {
                            props.DidYouKnowData.desc
                        }
                    </div>
                    : <></>
            }

            <div className={convertToModule(styles, 'socila-icon-container')}>
                {
                    props.isMobile ?
                        icons.map((eachIcon, index) => {
                            return (
                                <img src={HK.getImage(eachIcon)} alt={eachIcon} key={'icon_' + index} onClick={() => openSharePopup(index + 1)} />
                            )
                        })
                        :
                        <div className={convertToModule(styles, 'desk-field-cntnr')}>
                            <a className="custom-share-pop fb-xfbml-parse-ignore" target="popup" href={`https://www.facebook.com/sharer/sharer.php?u=${rneBaseUrl}&quote=${getShareDetails()}}. Click on ${rneBaseUrl} to get started.`} onClick={() => openSharePopup(1)}>
                                <img src={HK.getImage('/truebasics/social/fb-colored.svg')} alt="Share on Facebook" />
                            </a>
                            <a href={`https://twitter.com/share?text=${getShareDetails()}}. Click on ${rneBaseUrl} to get started.`} target="popup" className="share-twitter twitter-share-button custom-share-pop" data-show-count="false" onClick={() => openSharePopup(2)}>
                                <img src={HK.getImage('/ReferAndEarn/twitter-colored.svg')} alt="Share on Twitter" />
                            </a>
                            <a href={`https://www.instagram.com/?text=${getShareDetails()}}. Click on ${rneBaseUrl} to get started.`} target="popup" className="share-insta" data-show-count="false" onClick={() => openSharePopup(3)}>
                                <img src={HK.getImage('/ReferAndEarn/insta-colored.svg')} alt="Share on Insta" />
                            </a>
                        </div>
                }
            </div>
            <div className={convertToModule(styles, 'seperatos-cntnr')}>
                <div className={convertToModule(styles, 'ttl-seperatos')}>or</div>
            </div>

            <div className={convertToModule(styles, 'refral-code-cta-cntnr')}>
                {
                    referEarnCode ?
                        <div className={convertToModule(styles, 'code-txt')}>
                            {referEarnCode}
                        </div>
                        : <></>
                }
                {
                    referEarnCode ?
                        <img onClick={() => { navigator.clipboard.writeText(referEarnCode); setIsCoppied(true), handleReferAndEvent('Copy Code'); }} src={HK.getImage(isCoppied ? '/ReferAndEarn/copied-btn.svg' : '/ReferAndEarn/copy-btn.svg')} alt="copy-btn" className={convertToModule(styles, 'copy-cta')} />
                        : <></>
                }
            </div>
        </div>
    )

}
export default connect(null, null)(ShareOptionContainer);
